import React from "react";

export const AccessoryCardSkeleton = () => (
  <li className="acc-card is-skeleton" aria-hidden="true">
    <span className="acc-card-button">
      <span className="acc-card-media">
        <span className="acc-shimmer acc-shimmer-media" />
      </span>

      <span className="acc-card-body">
        <span className="acc-shimmer acc-shimmer-line acc-shimmer-name" />

        <span className="acc-card-desc is-skeleton">
          <span className="acc-shimmer acc-shimmer-line" />
          <span className="acc-shimmer acc-shimmer-line acc-shimmer-short" />
        </span>

        <span className="acc-card-facts">
          <span className="acc-shimmer acc-shimmer-line acc-shimmer-supplier" />
          <span className="acc-shimmer acc-shimmer-line acc-shimmer-price" />
        </span>
      </span>
    </span>
  </li>
);

export const AccessoryGridSkeleton = ({ cards = 10 }) => (
  <ul className="acc-grid" aria-hidden="true">
    {Array.from({ length: cards }, (unused, index) => (
      <AccessoryCardSkeleton key={index} />
    ))}
  </ul>
);

const CHIP_LABEL_WIDTHS = [24, 32, 42, 52, 40, 50, 66, 38];

export const CategoryChipsSkeleton = ({ chips = 8 }) => (
  <div className="acc-tabs-track is-skeleton" aria-hidden="true">
    {Array.from({ length: chips }, (unused, index) => (
      <span
        key={index}
        className={`acc-tab is-skeleton${index === 0 ? " is-lead" : ""}`}
      >
        <span
          className="acc-tab-skeleton"
          style={{ width: CHIP_LABEL_WIDTHS[index % CHIP_LABEL_WIDTHS.length] }}
        />
      </span>
    ))}
  </div>
);

export const AccessoryDetailSkeleton = () => (
  <div className="acc-detail-skeleton" aria-hidden="true">
    <span className="acc-shimmer acc-shimmer-supplier-row" />
    <span className="acc-shimmer acc-shimmer-line acc-shimmer-title" />
    <span className="acc-shimmer acc-shimmer-line" />
    <span className="acc-shimmer acc-shimmer-line acc-shimmer-short" />
    <span className="acc-shimmer acc-shimmer-block" />
  </div>
);
